
import React, { useState } from 'react';
import { FileText, ChevronRight, Activity, Smartphone, BarChart2, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Reports = () => {
    const { t } = useLanguage();
    const [preparingReport, setPreparingReport] = useState(null);

    const reportTypes = [
        {
            id: 'monthly',
            title: t('reports.monthlyPerformance'),
            description: t('reports.monthlyPerformanceDesc'),
            icon: Activity,
            color: 'bg-blue-100 text-blue-600'
        },
        {
            id: 'device',
            title: t('reports.deviceStatus'),
            description: t('reports.deviceStatusDesc'),
            icon: Smartphone,
            color: 'bg-green-100 text-green-600'
        },
        {
            id: 'usage',
            title: t('reports.usageStats'),
            description: t('reports.usageStatsDesc'),
            icon: BarChart2,
            color: 'bg-purple-100 text-purple-600'
        }
    ];

    const handleReportClick = (id) => {
        setPreparingReport(id);
        // 3 saniye sonra mesajı kaldır
        setTimeout(() => {
            setPreparingReport(null);
        }, 3000);
    };

    return (
        <div className="min-h-screen bg-gray-50 p-8 space-y-6">
            {/* Header */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 flex flex-col gap-2 transition-shadow duration-200">
                <div className="flex items-center gap-3">
                    <div className="p-3 bg-gray-100 rounded-lg text-indigo-600">
                        <FileText size={24} />
                    </div>
                    <h1 className="text-2xl font-bold text-slate-900">{t('reports.title')}</h1>
                </div>
                <p className="text-slate-700 ml-14">{t('reports.subtitle')}</p>
            </div>

            {/* Report Options Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {reportTypes.map((report) => {
                    const Icon = report.icon;
                    return (
                        <div
                            key={report.id}
                            onClick={() => handleReportClick(report.id)}
                            className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow duration-200 hover:border-gray-300 group relative overflow-hidden"
                        >
                            <div className="flex items-start justify-between mb-4">
                                <div className={`p-3 rounded-lg ${report.color} group-hover:scale-110 transition-transform duration-300`}>
                                    <Icon size={24} />
                                </div>
                                <ChevronRight className="text-slate-300 group-hover:text-indigo-400 transition-colors duration-200" />
                            </div>

                            <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors duration-200">
                                {report.title}
                            </h3>
                            <p className="text-sm text-slate-700 leading-relaxed">
                                {report.description}
                            </p>

                            {/* Preparing Overlay */}
                            {preparingReport === report.id && (
                                <div className="absolute inset-0 bg-white/95 flex flex-col items-center justify-center text-center p-4 animate-in fade-in duration-200">
                                    <Clock className="w-8 h-8 text-indigo-600 animate-spin mb-3" />
                                    <p className="text-indigo-900 font-semibold">{t('reports.preparing')}</p>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Reports;
